import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddCountryRequest } from '../models/request/country/AddCountryRequest';
import { GetCountryListPagingAndFilterRequest } from '../models/request/country/GetCountryListPagingAndFilterRequest';

export class CountryService {
    static async getCountryList(_code?: string) {
        try {
            var inputObj = {
                code: _code
            };

            console.log('SERVICE CALL - getCountryList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/getCountryList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCountryList(inputObj: GetCountryListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCountryList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/exportCountryList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCountryListPagingAndFilter(inputObj: GetCountryListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCountryListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/GetCountryListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addCountry(inputObj: AddCountryRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddCountry', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/AddCountry', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCountry(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCountry', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/deleteCountry', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCountryById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCountryById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Country/getCountryById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}